import { render, staticRenderFns } from "./vMessage.vue?vue&type=template&id=070696b4&scoped=true&"
import script from "./vMessage.vue?vue&type=script&lang=js&"
export * from "./vMessage.vue?vue&type=script&lang=js&"
import style0 from "./vMessage.vue?vue&type=style&index=0&id=070696b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070696b4",
  null
  
)

export default component.exports